import { z } from 'zod'

import { viewQueryAggregationSchema } from './aggregation.ts'
import { viewQueryListSchema } from './list.ts'
import { viewQueryMultiTablePivotSchema } from './multi_table_pivot.ts'

export type ViewQueryRecordNode = ViewQueryRecordNodeWithId | ViewQueryRecordNodeWithoutId

export type ViewQueryRecordNodeWithId = {
  id: string
} & ViewQueryRecordNodeBase

type ViewQueryRecordNodeWithoutId = {
  id: undefined
} & ViewQueryRecordNodeBase

interface ViewQueryRecordNodeBase {
  attributes: Record<string, unknown>
  meta: {
    height: number
    innerRowIndexStart: number
    innerRowIndexEnd: number
    // eslint-disable-next-line sonarjs/todo-tag
    highlightAttributeNames?: string[] // TODO: 後から適切な形式を考える予定
  }
  children: ViewQueryTableNode[]
}

export interface ViewQueryTableNode {
  nodeName: string
  children: ViewQueryRecordNode[]
}

export interface ViewQueryResultCursor {
  page: number
  pageSize: number
  chunkSize: number
  nextId: string
}

export interface ViewQueryResultUi {
  pivotColumns?: ViewQueryResultUiPivotColumn[]
}

export interface ViewQueryResultUiPivotColumn {
  columnFieldName: string
  valuesWithLabel: Array<{ value: string; label: string | undefined }>
}

export type ViewQueryResultSnapshot = Record<
  string, // NodeName
  Record<
    string, // recordId
    Record<
      string, // day
      Record<string, unknown>
    >
  >
>

type ViewQueryVersion = 'v1.0.0' | undefined

export const viewQuerySchema = z.union([
  viewQueryListSchema,
  viewQueryAggregationSchema,
  viewQueryMultiTablePivotSchema,
])
export type ViewQuery = z.infer<typeof viewQuerySchema>

export interface ViewQueryResult {
  viewQuery: ViewQuery
  result: ViewQueryRecordNode[]
  nextCursor: ViewQueryResultCursor | undefined
  ui?: ViewQueryResultUi
  /**
   * @deprecated sqlDetailsを利用する
   */
  sqls?: string[]
  sqlDetails?: Array<{
    sql: string // 実際に実行されたSQL
    originalRawSql: string // 自動生成されたSQL(Mustache含む)。上書きが適用されていると、実行されたSQLとは構造が異なる場合がある
    overriddenRawSql: string | undefined // 上書きされたSQL(Mustache含む)
    mustacheParameter: Record<string, unknown>
    name: string
  }>
  queryResultMeta?: unknown
  error?: string
  warn?: string // errorのときはclient側で表示されない(resultを格納しない)が、warnのときは表示される
  // eslint-disable-next-line sonarjs/no-redundant-optional
  version?: ViewQueryVersion
  snapshots?: ViewQueryResultSnapshot
}
